import * as citiesList from './citiesList';

import {combineReducers} from "redux";
import {all, fork} from "redux-saga/effects";

export interface IState  {
    citiesList: citiesList.IState
}

export const ActionCreators = {
    citiesList: citiesList.ActionCreators
}

export const Reducers = combineReducers<IState>({
    citiesList: citiesList.Reducers
});

export function* sagas() {
    yield all([
        fork(citiesList.sagas)
    ]);
}
